import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './counterSlice';
import { allAdminSlices } from './AdminSlices/allAdminSlices';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    ...allAdminSlices,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
